import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DaumPostcode from "@/components/modal/DaumPostcode";
import { DialogButton, Icon, TextField } from "@bookips/sds";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { formatDashPhoneNumberToNumber, formatPhoneNumberToDash } from "../utils/formatNumber";
export const AddressManagementAdd = (param)=>{
    let { addressData , onAddressSave , onClose , isLoading =false  } = param;
    var _errors_addressName, _errors_recipientName, _errors_address2;
    const { register , watch , setValue , control , formState: { errors  } , handleSubmit  } = useForm({
        defaultValues: {
            addressName: (addressData === null || addressData === void 0 ? void 0 : addressData.addressName) || "",
            recipientName: (addressData === null || addressData === void 0 ? void 0 : addressData.recipientName) || "",
            phone: (addressData === null || addressData === void 0 ? void 0 : addressData.phone) || "",
            address1: (addressData === null || addressData === void 0 ? void 0 : addressData.address1) || "",
            address2: (addressData === null || addressData === void 0 ? void 0 : addressData.address2) || "",
            postalCode: (addressData === null || addressData === void 0 ? void 0 : addressData.postalCode) || "",
            deliveryNote: (addressData === null || addressData === void 0 ? void 0 : addressData.deliveryNote) || ""
        }
    });
    const [open, setOpen] = useState(false);
    const onSubmit = async (data)=>{
        try {
            await onAddressSave({
                ...data,
                phone: formatDashPhoneNumberToNumber(data.phone)
            });
        } catch (error) {
            ;
        // 에러 발생 시 다이얼로그는 열어둠
        }
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: open ? /*#__PURE__*/ _jsxs("div", {
            className: "w-full h-[550px]",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "w-full flex justify-end items-end px-5 absolute top-7 right-0 cursor-pointer",
                    children: /*#__PURE__*/ _jsx(Icon.Close_2px, {
                        className: "size-5",
                        onClick: ()=>setOpen(false)
                    })
                }),
                /*#__PURE__*/ _jsx(DaumPostcode, {
                    style: {
                        width: "100%",
                        height: "100%",
                        border: "none"
                    },
                    onComplete: (data)=>{
                        setValue("address1", data.address, {
                            shouldValidate: true
                        });
                        setValue("postalCode", data.zonecode);
                        setValue("address2", "");
                        setOpen(false);
                    }
                }, new Date().getTime())
            ]
        }) : /*#__PURE__*/ _jsxs("div", {
            className: "w-full h-full max-h-[calc(100vh-98px)] px-7 flex flex-col gap-5 max-sm:px-0",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ _jsx(TextField, {
                            labelText: "배송지명 *",
                            placeholder: "배송지명을 입력해주세요.",
                            size: "lg",
                            maxLength: 20,
                            error: !!errors.addressName,
                            helperText: (_errors_addressName = errors.addressName) === null || _errors_addressName === void 0 ? void 0 : _errors_addressName.message,
                            ...register("addressName", {
                                required: "필수 입력 사항이에요.",
                                maxLength: {
                                    value: 20,
                                    message: "20자 이하로 입력해주세요."
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            labelText: "받는 사람 *",
                            placeholder: "받는 사람의 이름을 입력해주세요.",
                            size: "lg",
                            maxLength: 20,
                            error: !!errors.recipientName,
                            helperText: (_errors_recipientName = errors.recipientName) === null || _errors_recipientName === void 0 ? void 0 : _errors_recipientName.message,
                            ...register("recipientName", {
                                required: "필수 입력 사항이에요.",
                                maxLength: {
                                    value: 20,
                                    message: "20자 이하로 입력해주세요."
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Controller, {
                            name: "phone",
                            control: control,
                            rules: {
                                required: "필수 입력 사항이에요."
                            },
                            render: (param)=>{
                                let { field  } = param;
                                var _errors_phone;
                                /*#__PURE__*/ return _jsx(TextField, {
                                    labelText: "전화번호 *",
                                    placeholder: "받는 사람의 전화번호를 입력해주세요.",
                                    size: "lg",
                                    value: field.value ? formatPhoneNumberToDash(field.value) : "",
                                    error: !!errors.phone,
                                    helperText: (_errors_phone = errors.phone) === null || _errors_phone === void 0 ? void 0 : _errors_phone.message,
                                    onChange: (e)=>{
                                        const formatted = formatPhoneNumberToDash(e.target.value);
                                        field.onChange(formatted);
                                    }
                                });
                            }
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ _jsx(TextField, {
                                    labelText: "주소 *",
                                    placeholder: "주소 찾기",
                                    size: "lg",
                                    readOnly: true,
                                    error: !!errors.address1,
                                    endIcon: /*#__PURE__*/ _jsx(Icon.Search_2px, {
                                        className: "size-4"
                                    }),
                                    onClick: ()=>{
                                        setOpen(true);
                                    },
                                    ...register("address1", {
                                        required: "필수 입력 사항이에요."
                                    })
                                }),
                                /*#__PURE__*/ _jsx(TextField, {
                                    placeholder: "상세주소를 입력해주세요.",
                                    size: "lg",
                                    maxLength: 20,
                                    error: !!errors.address2,
                                    helperText: (_errors_address2 = errors.address2) === null || _errors_address2 === void 0 ? void 0 : _errors_address2.message,
                                    ...register("address2", {
                                        required: "필수 입력 사항이에요.",
                                        maxLength: {
                                            value: 20,
                                            message: "20자 이하로 입력해주세요."
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            labelText: "배송 요청사항 (선택)",
                            placeholder: "배송 시 요청 사항을 입력해주세요.",
                            size: "lg",
                            maxLength: 50,
                            ...register("deliveryNote", {
                                maxLength: {
                                    value: 50,
                                    message: "50자 이하로 입력해주세요."
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "pb-7 max-sm:pb-5",
                    children: /*#__PURE__*/ _jsx(DialogButton, {
                        cancelText: "취소",
                        confirmText: "저장",
                        onConfirm: handleSubmit(onSubmit),
                        onCancel: onClose,
                        classes: {
                            confirmButton: "max-sm:w-full",
                            cancelButton: "max-sm:w-full",
                            root: "p-0"
                        }
                    })
                })
            ]
        })
    });
};
